import { check } from '@fingermarkglobal/validation';
import { CancelOrderPayload } from '@fingermarkglobal/types';
import { request, getJwtToken } from '@fingermarkglobal/request';
import { buildRequestOptions, buildOrderCancelEndpoint } from '../../shared';

const cancelOrder = async (
  payload: CancelOrderPayload,
  timeout: number = 30,
  ip: string = '',
  provider: string = '',
) => {
  try {
    logger.info('[fm-api][order/cancel] - started');

    const invalid = check({
      name: 'cancelOrder',
      parameters: { payload },
    });
    if (invalid) throw new Error(`[fm-api][order/cancel] - failed to validate parameters [${invalid}]`);

    const { customCancelOrderEndpoint: customEndpoint } = payload?.settings?.labs || {};
    const endpoint = buildOrderCancelEndpoint({customEndpoint, ip, provider});

    const token = await getJwtToken();
    if (!token) throw new Error(`[fm-api][order/cancel] error generating jwt token`);

    const options = buildRequestOptions({
      endpoint,
      token,
      timeout,
      payload,
    });

    const response = provider == 'orderserve' || provider == 'bsp' || provider.toLowerCase() == 'oraclemicros'
        ? await request.patch(endpoint, options).json()
        : await request.post(endpoint, options).json();

    if (!response) throw new Error(`[fm-api][order/cancel] - failed with response {${response}}`);

    return response;
  } catch (err) {
    logger.error('[fm-api][order/cancel] - error:', err);
    throw err;
  } finally {
    logger.info('[fm-api][order/cancel] - finished');
  }
};

export { cancelOrder };
